export const Ping = () => (
  <span className="relative flex w-2 h-2 ml-1">
    <span className="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-90 animate-ping"></span>
    <span className="relative inline-flex w-2 h-2 bg-red-500 rounded-full"></span>
  </span>
);
